import React from "react";
import HeaderWithSearch from "./HeaderWithSearch";
import ImageWithFallback from "./ImageWithFallback";

function CharredCornSalad() {
  return (
    <>
      <HeaderWithSearch />
      <main style={{
        minHeight: "100vh",
        width: "100%",
        background: "linear-gradient(180deg, #e3f0fc 0%, #fafdff 100%)",
        padding: 0,
        margin: 0
      }}>
        <section className="recipe-hero-anim" style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "40vh",
          padding: "60px 0 20px 0"
        }}>
          <h1 className="recipe-title-anim" style={{ fontSize: "3rem", fontWeight: "bold", marginBottom: 12 }}>Charred Corn Salad</h1>
          <p style={{ fontSize: "1.3rem", color: "#333", marginBottom: 16 }}>A fresh, smoky, and tangy summer salad packed with flavor and crunch.</p>
          <span className="season-badge season-summer">☀️ Best in Summer</span>
          <ImageWithFallback src="/charred-corn.jpg" alt="Charred Corn Salad" className="recipe-image-anim" style={{ width: 340, borderRadius: 24, boxShadow: "0 4px 32px rgba(0,0,0,0.10)", marginBottom: 24, marginTop: 16 }} />
        </section>
        <section className="recipe-columns-anim" style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "flex-start",
          gap: 48,
          padding: "20px 0 0 0",
          maxWidth: 1200,
          margin: "0 auto"
        }}>
          <div style={{ flex: 1, minWidth: 320 }}>
            <h2 style={{ fontSize: "2rem", fontWeight: 600, marginBottom: 16, color: "#1a3a5d" }}>Ingredients</h2>
            <ul className="ingredient-list" style={{ fontSize: "1.1rem", color: "#444", lineHeight: 1.7, marginLeft: 18 }}>
              <li>3 ears fresh corn, husked</li>
              <li>1 cup cherry tomatoes, halved</li>
              <li>1/2 small red onion, finely chopped</li>
              <li>1/2 cup feta cheese, crumbled</li>
              <li>1/4 cup fresh cilantro, chopped</li>
              <li>1 jalapeño, seeded and minced (optional)</li>
              <li>2 tbsp olive oil</li>
              <li>Juice of 1 lime</li>
              <li>Salt and pepper to taste</li>
            </ul>
          </div>
          <div style={{ flex: 2, minWidth: 320 }}>
            <h2 style={{ fontSize: "2rem", fontWeight: 600, marginBottom: 16, color: "#1a3a5d" }}>Instructions</h2>
            <ol className="instructions-list" style={{ fontSize: "1.1rem", color: "#444", lineHeight: 1.7, marginLeft: 18 }}>
              <li>Heat a grill or grill pan over high heat. Brush corn with 1 tbsp olive oil and grill, turning occasionally, until charred in spots (8-10 minutes). Let cool, then cut kernels off the cob.</li>
              <li>In a large bowl, combine charred corn, cherry tomatoes, red onion, feta, cilantro, and jalapeño.</li>
              <li>Drizzle with remaining olive oil and lime juice. Season with salt and pepper. Toss well to combine.</li>
              <li>Serve immediately or chill for 30 minutes for flavors to meld. Enjoy!</li>
            </ol>
          </div>
        </section>
        <section style={{ maxWidth: 1200, margin: "0 auto", padding: "24px 24px 60px 24px", display: "flex", gap: 32, flexWrap: "wrap" }}>
          <div className="chef-tips-box" style={{ flex: 1, minWidth: 300, background: "#f8f9fa", padding: 20, borderRadius: 12 }}>
            <h3 style={{ fontSize: "1.3rem", fontWeight: 600, marginBottom: 12 }}>
              <span className="tip-icon" role="img" aria-label="chef">👨‍🍳</span> Chef's Tips
            </h3>
            <ul style={{ paddingLeft: 20 }}>
              <li>Let the grill get really hot before adding the corn — you want char, not just steam.</li>
              <li>Stand the cob in the center of a bundt pan to catch every kernel as you slice it off.</li>
              <li>Salt the salad right before serving so the tomatoes don't release excess water.</li>
              <li>Swap feta for cotija cheese for a more traditional elote-style flavor.</li>
            </ul>
          </div>
          <div className="health-benefits-box" style={{ flex: 1, minWidth: 300, background: "#eef9f0", padding: 20, borderRadius: 12 }}>
            <h3 style={{ fontSize: "1.3rem", fontWeight: 600, marginBottom: 12 }}>
              <span className="tip-icon" role="img" aria-label="health">🌿</span> Health Benefits
            </h3>
            <ul style={{ paddingLeft: 20 }}>
              <li>Corn provides fiber and B vitamins that support digestion and energy metabolism.</li>
              <li>Tomatoes are rich in lycopene, an antioxidant linked to heart health.</li>
              <li>Olive oil and lime add heart-healthy fats and vitamin C without heavy dressing.</li>
              <li>A naturally gluten-free, veggie-forward side that's light but satisfying.</li>
            </ul>
          </div>
        </section>
      </main>
    </>
  );
}

export default CharredCornSalad;
